<template>
   <div class="container-fluid">
      <div class="row">
         <div class="container">
            <div class="row">
               <div class="col-12 sport-panel">
                  <router-link
                      to="/sport/prematch"
                      class="btn btn-link btn-sport"
                      :class="[ type === 'prematch' ? 'active' : '' ]"
                  >
                     {{t('panel.link.sport.prematch')}}
                  </router-link>
                  <router-link
                      to="/sport/live"
                      class="btn btn-link btn-sport"
                      :class="[ type === 'live' ? 'active' : '' ]"
                  >
                     {{t('panel.link.sport.live')}}
                  </router-link>
               </div>
            </div>
         </div>
      </div>
      <div class="row">
         <iframe
             id="seven-plugin"
             :src="url"
             frameborder="0"
             scrolling="no"
             style="width: 100%;">
         </iframe>
      </div>
   </div>
</template>

<script>

const {iframeResize} = require('iframe-resizer');

import {sportBetting} from "@/config";
import Vuex from 'vuex';



export default {
   name: "SevenSportBetting",

   data(){return{
      authStrategy: 'token', //tempToken
   }},
   computed:{
      ...Vuex.mapState([
         'lang'
      ]),
      ...Vuex.mapGetters({
         user: 'getUser',
         userLogedIn: 'getUserStatus'
      }),
      type(){

         switch (this.$route.name){
            case 'SportLive':
               return 'live';
            case 'SportPreMatch':
               return 'prematch';

         }
      },

      url(){
         //  $url?auth=$auth&token=$token&id=$id&authStrategy=$authStrategy
         const domain = this.$store.state.sport.domain;

         let url = `${domain}${sportBetting.url[this.type]}?lang=${this.lang}&currency=EUR&auth=b2b`

         if(this.user && this.user.sid && this.user.id){
            url+= `&authStrategy=${this.authStrategy}`;
            url+= `&id=${this.user.id}`;
            url+= `&token=${this.user.sid}`;
         }else{
            url+= `&logout=true`;
         }

         return url;
      }
   },
   mounted(){

      const iframe = document.querySelector('#seven-plugin')
      iframeResize({
         checkOrigin: [
            ...Object.values(sportBetting.url).map(l => this.$store.state.sport.domain+l),

            this.$store.state.sport.domain
         ],
         log: false,
         autoResize: true,
         bodyPadding: 0,
         heightCalculationMethod: 'documentElementOffset',//'bodyOffset',
         onMessage: this.messageHandler,
         initCallback: function (iframe) {
            const footerH = document.querySelector('.site-footer')


            function calcHeights(wi){
               // .site-header
               //.page__account-bar
               //.sport-panel
               function getHeight(query){
                  const element = document.querySelector(query);
                  if(element && element.offsetHeight){
                     return element.offsetHeight
                  }
                  return 0;
               }
               let negativeHeights = 0;
               const panels = [
                  '.site-header',
                  '.page__account-bar',
                  '.sport-panel'
               ];
               for (let q of panels){
                  negativeHeights+= getHeight(q)
               }
               console.log(negativeHeights)
               return (wi.innerHeight - negativeHeights)
            }
            iframe.style.height = calcHeights(window) + "px";



            window.addEventListener("resize", function(e){
                   iframe.style.height = calcHeights(window)  + "px";
                }
            ); }

      }, '#seven-plugin');

   },
   methods:{
      messageHandler(data){
         if (data.message && data.message.type) {
            switch (data.message.type) {

               case 'contentLoaded':
               case 'logout':
                  this.$store.dispatch('userRefreshAction');
                  break;

               case 'ticketResolved':
               case 'roundFinished':
               case 'logoutSuccess':
               case 'listenersReady':
                  console.log(data.message)
                  break;
               case 'loginRequired':
                  this.$store.commit('showLoginModal');
                  console.log(data.message)
                  break;
            }
         }
      }
   }
}
</script>

<style scoped lang="scss">
#seven-plugin{
   //min-height: 800vh;
}
.sport-panel{
   display: flex;
   align-items: center;
   justify-content: space-around;
   padding-top: 15px;
   padding-bottom: 15px;

}
.btn-sport{
   border-bottom: 4px solid transparent;
   font-style: italic;
   font-size: 14px;
   text-decoration: none!important;
   color: #303539;
   &.active{
      border-bottom-color: #f18430;
   }
}

</style>
